import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect, useState } from "react";
import {
  Grid,
  Icon,
  IconButton,
  Box,
  List,
  ListItem,
  Divider,
  TextField,
  Typography,
  Badge,
  useTheme,
} from "@mui/material";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "../CTLBaseDialogForm";
import {
  getColumns,
  Attributes,
  operationURLS,
} from "../CTLConferencePhone/model";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import CTLNotification from "../CTLNotification";
import loggerFactory from "globals/logger/logger-factory";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
function CTLConferenceUserList({ conferenceData, phoneType, openPopup }) {
  let click_To_Call = !!window.clickToCall;
  const theme = useTheme();
  const [participantList, setParticipantList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [callFunction, setCallFunction] = useState(false);
  const [activeUser, setActiveUser] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [raiseHand, setRaiseHand] = useState("info");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (callFunction) {
        fetchData(conferenceData);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [callFunction]);

  useEffect(() => {
    if (participantList) {
      const filtered = participantList.filter(
        (item) =>
          item.participantName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          item.extensions.includes(searchQuery)
      );
      setFilteredList(filtered);
    }
  }, [participantList, searchQuery, activeUser]);

  useEffect(() => {
    setCallFunction(openPopup);
  }, [openPopup]);

  useEffect(() => {
    fetchData(conferenceData);
  }, [conferenceData]);

  function fetchData(data) {
    if (data) {
      application
        .post(`conferenceParticipant/list/${data.modId}`)
        .then((response) => {
          setParticipantList(response.data.data);
        })
        .catch(() => {
          setParticipantList([]);
          loggerFactory.debug("Unable to load ParticipantList ");
        });

      application
        .post(`conferenceParticipant/confCallDetail/${data.accessCode}`)
        .then((response) => {
          setActiveUser(response.data.data);
        })
        .catch(() => {
          setActiveUser([]);
          loggerFactory.debug("Unable to load active Users ");
        });
    }
  }

  useEffect(() => {
    if (activeUser) {
      const number = AuthenticationService.getExtensionNumber();
      const matchedContact =
        activeUser && activeUser.find((item) => item.contact === number);
      if (matchedContact && matchedContact.isHandRaised == 0) {
        setRaiseHand("info");
      } else {
        setRaiseHand("success");
      }
    }
  }, [activeUser]);

  const handleRaiseHand = () => {
    fetchData(conferenceData);
    const number = AuthenticationService.getExtensionNumber();
    const matchedContact = activeUser.find((item) => item.contact === number);
    if (matchedContact) {
      setRaiseHand("success");
      application
        .post(`conferenceParticipant/updateHandRaise/${matchedContact.uuid}`)
        .then((response) => {
          setRaiseHand("success");
          setNotify({
            isOpen: true,
            type: "success",
            pagename: "Conference",
            status: response.data.message,
          });
        })
        .catch((error) => {
          loggerFactory.debug("Unable to update handRaise ", error);
        });
    } else {
      setNotify({
        isOpen: true,
        type: "warning",
        pagename: "Conference",
        status: `Unable to get ${AuthenticationService.getExtensionNumber()} data for hand raise update `,
      });
    }
  };

  const handleUnMute = (number) => {
    const matchedContact =
      activeUser && activeUser.find((item) => item.contact === number);
    if (matchedContact) {
      application
        .post(
          `conferenceParticipant/unmute/${conferenceData.accessCode}/${matchedContact.id}`
        )
        .then((response) => {
          fetchData(conferenceData);
          setNotify({
            isOpen: true,
            type: "success",
            pagename: "Conference",
            status: response.data.message,
          });
        })
        .catch(() => {
          loggerFactory.debug("Unable to UnMute participant ");
        });
    }
  };

  const handleMute = (number) => {
    const matchedContact =
      activeUser && activeUser.find((item) => item.contact === number);
    if (matchedContact) {
      application
        .post(
          `conferenceParticipant/mute/${conferenceData.accessCode}/${matchedContact.id}`
        )
        .then((response) => {
          fetchData(conferenceData);
          setNotify({
            isOpen: true,
            type: "success",
            pagename: "Conference",
            status: response.data.message,
          });
        })
        .catch(() => {
          loggerFactory.debug("Unable to Mute participant ");
        });
    }
  };

  const handleAddParticipant = () => {
    setOpenForm(true);
    setFormData({
      eventTime: Date.now(),
    });
  };

  function onCloseForm() {
    setOpenForm(false);
  }

  function onSaveForm(data) {
    const dataToSave = {
      configureConferrerId: conferenceData.modId,
      ...data,
    };
    application
      .post(operationURLS.create, dataToSave)
      .then((response) => {
        fetchData(conferenceData);
        setNotify({
          isOpen: true,
          type: "success",
          pagename: "Conference",
          status: response.data.messageDetail,
        });
        setOpenForm(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          type: "error",
          pagename: "Conference",
          status: error.response.data.status,
        });
      });
  }

  const getColorForContact = (contactNumber) => {
    if (activeUser) {
      const activeContacts = activeUser.map((user) => user.contact);
      if (activeContacts.includes(contactNumber)) {
        return "success";
      }
    }
    return "error";
  };

  const getColorCallType = (contactNumber) => {
    if (activeUser) {
      const matchedContact = activeUser.find(
        (item) => item.contact === contactNumber
      );
      return matchedContact && matchedContact.hasVideo === "true";
    }
    return false;
  };

  const getHandRaise = (contactNumber) => {
    if (activeUser) {
      const matchedContact =
        activeUser && activeUser.find((item) => item.contact === contactNumber);
      return matchedContact ? matchedContact.isHandRaised : 0;
    }
  };

  const getMuteStatus = (contactNumber) => {
    if (activeUser) {
      const matchedContact =
        activeUser && activeUser.find((item) => item.contact === contactNumber);
      return matchedContact && matchedContact.canSpeak != "false";
    }
  };

  const handleAccessRaiseHand = (contactNumber) => {
    const matchedContact =
      activeUser && activeUser.find((item) => item.contact === contactNumber);
    const adminContact = AuthenticationService.getExtensionNumber();
    if (matchedContact) {
      application
        .post(
          `conferenceParticipant/unMuteRaisedUser/${conferenceData.didMapping}/${conferenceData.accessCode}/${matchedContact.id}/${adminContact.id}`
        )
        .then(() => {
          fetchData(conferenceData);
        })
        .catch(() => {
          loggerFactory.debug("Unable to unMuteRaiseUser ");
        });
    }
  };

  const call = (data) => {
    const updatedConferenceData = {
      ...conferenceData,
      conferenceNumber: conferenceData.didMapping,
    };
    const isModerator =
      conferenceData.createdBy !== data.participantName ? false : true;
    const participantNumbers = Array.isArray(data.extensions)
      ? [...data.extensions]
      : [data.extensions];
    const updatedData = {
      conferenceId: data.accessCode,
      participantNumber: participantNumbers,
      conferenceNumber: updatedConferenceData.conferenceNumber,
      isModerator,
    };
    application
      .post(`conferenceParticipant/dialConference`, updatedData)
      .then((response) => {
        setNotify({
          isOpen: true,
          type: "success",
          pagename: "Conference",
          status: response.data.message,
        });
      });
  };

  const handleParticipantDelete = (contactNumber) => {
    const matchedContact =
      activeUser &&
      activeUser.find((item) => {
        return (
          item.contact === contactNumber.extensions ||
          item.contact === contactNumber.mobileNumber
        );
      });
    if (matchedContact) {
      application
        .post(
          `conferenceParticipant/${conferenceData.accessCode}/kick/${matchedContact.id}/${matchedContact.contact}`
        )
        .then((response) => {
          fetchData(conferenceData);
          setNotify({
            isOpen: true,
            type: "success",
            pagename: "Conference",
            status: response.data.messageDetail,
          });
        });
    }
  };

  const handleExternalParticipantDelete = (contactNumber) => {
    if (contactNumber) {
      application
        .post(
          `conferenceParticipant/${conferenceData.accessCode}/kick/${contactNumber.id}/${contactNumber.contact}`
        )
        .then((response) => {
          fetchData(conferenceData);
          setNotify({
            isOpen: true,
            type: "success",
            pagename: "Conference",
            status: response.data.messageDetail,
          });
        });
    }
  };

  return (
    <>
      <MDBox
        role="presentation"
        sx={{
          border: (theme) =>
            `1px solid ${
              darkMode ? theme.palette.common.white : theme.palette.common.black
            }`,
          borderRadius: 2,
          padding: 1,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <MDTypography variant="h4" sx={{ flex: 1, textAlign: "center" }}>
            Participant List
          </MDTypography>
          <TextField
            label="Search Participant"
            variant="outlined"
            size="medium"
            value={searchQuery}
            onChange={handleSearchInputChange}
            autoComplete="off"
            sx={{ width: "300px" }}
          />
        </Box>
        {/* Table Header */}
        <Grid
          container
          sx={{
            backgroundColor: "gray",
            color: "primary.contrastText",
            py: 1,
            px: 1,
            fontWeight: "bold",
            borderRadius: 1,
          }}
        >
          <Grid item xs={conferenceData.passwordRequired ? 3 : 4}>
            <Typography variant="body1">Participant Name</Typography>
          </Grid>
          <Grid item xs={conferenceData.passwordRequired ? 3 : 4}>
            <Typography variant="body1">Participant Number</Typography>
          </Grid>

          {conferenceData.passwordRequired && (
            <Grid item xs={3}>
              <Typography variant="body1">Password</Typography>
            </Grid>
          )}
          <Grid item xs={conferenceData.passwordRequired ? 3 : 4}>
            <Typography variant="body1">
              {conferenceData?.createdBy == AuthenticationService.getUserName()
                ? "Action"
                : "Status"}
            </Typography>
          </Grid>
        </Grid>
        <List sx={{ height: "100%", overflowY: "auto", p: 0 }}>
          {filteredList && filteredList.length === 0 ? (
            <MDTypography variant="h6" sx={{ textAlign: "center" }}>
              No participant found
            </MDTypography>
          ) : (
            filteredList &&
            filteredList.map((item, index) => (
              <ListItem
                key={item.participantId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 2,
                  py: 1,
                  backgroundColor:
                    index % 2 === 0
                      ? theme.palette.background.default
                      : theme.palette.action.hover,
                }}
              >
                <Grid container alignItems="center" sx={{ flex: 1 }}>
                  <Grid item xs={conferenceData.passwordRequired ? 3 : 4}>
                    <MDTypography variant="body2">
                      <PersonIcon
                        sx={{ mr: 1 }}
                        color={
                          getColorForContact(
                            item.mobileNumber || item.extensions
                          ) === "error"
                            ? "error"
                            : "success"
                        }
                        fontSize="medium"
                      />{" "}
                      {item.participantName}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={conferenceData.passwordRequired ? 3 : 4}>
                    <MDTypography variant="body2">
                      {item.extensions || item.mobileNumber}
                    </MDTypography>
                  </Grid>
                  {conferenceData.passwordRequired && (
                    <Grid item xs={3}>
                      <MDTypography variant="body2">
                        {item.conferencePassword || (
                          <span style={{ color: "#999" }}>N/A</span>
                        )}
                      </MDTypography>
                    </Grid>
                  )}
                  <Grid item xs={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {conferenceData?.createdBy ==
                        AuthenticationService.getUserName() &&
                        getColorForContact(
                          item.mobileNumber || item.extensions
                        ) === "error" && (
                          <tooltip title="Dial Participant">
                            <IconButton onClick={() => call(item)}>
                              <Icon color="error">phone</Icon>
                            </IconButton>
                          </tooltip>
                        )}
                      {getColorForContact(
                        item.mobileNumber || item.extensions
                      ) === "success" &&
                        (getColorCallType(
                          item.mobileNumber || item.extensions
                        ) ? (
                          <MDTypography variant="body2">
                            Joined via Video Call
                          </MDTypography>
                        ) : (
                          <MDTypography variant="body2">
                            Joined via Audio Call
                          </MDTypography>
                        ))}
                      {phoneType === "moderator" &&
                        conferenceData?.rptt &&
                        getColorForContact(
                          item.mobileNumber || item.extensions
                        ) === "success" &&
                        getHandRaise(item.mobileNumber || item.extensions) ==
                          1 && (
                          <IconButton
                            onClick={() =>
                              handleAccessRaiseHand(
                                item.mobileNumber || item.extensions
                              )
                            }
                          >
                            <Badge
                              badgeContent={getHandRaise(
                                item.mobileNumber || item.extensions
                              )}
                              color="error"
                            >
                              <Icon color="warning">pan_tool_icon</Icon>
                            </Badge>
                          </IconButton>
                        )}
                      {phoneType === "moderator" &&
                        getColorForContact(
                          item.extensions || item.mobileNumber
                        ) === "success" &&
                        (getMuteStatus(item.extensions || item.mobileNumber) ? (
                          <tooltip title="Unmute">
                            <IconButton
                              onClick={() =>
                                handleMute(item.extensions || item.mobileNumber)
                              }
                            >
                              <Icon color="success">mic</Icon>
                            </IconButton>
                          </tooltip>
                        ) : (
                          <tooltip title="Mute">
                            <IconButton
                              onClick={() =>
                                handleUnMute(
                                  item.extensions || item.mobileNumber
                                )
                              }
                            >
                              <Icon color="error">mic_off</Icon>
                            </IconButton>
                          </tooltip>
                        ))}
                      {item.createdBy === AuthenticationService.getUserName() &&
                        !item.isVip &&
                        getColorForContact(
                          item.mobileNumber || item.extensions
                        ) === "success" && (
                          <tooltip title={"Remove"}>
                            <IconButton
                              onClick={() => handleParticipantDelete(item)}
                            >
                              <Icon color="error">
                                remove_circle_outline_icon
                              </Icon>
                            </IconButton>
                          </tooltip>
                        )}
                    </Box>
                  </Grid>
                </Grid>
              </ListItem>
            ))
          )}
        </List>
        <MDBox
          role="presentation"
          sx={{
            border: (theme) =>
              `1px solid ${
                darkMode
                  ? theme.palette.common.white
                  : theme.palette.common.black
              }`,
          }}
        ></MDBox>
        <List sx={{ height: "100%", overflowY: "auto", p: 0 }}>
          {activeUser && activeUser.length === 0 ? (
            <MDTypography variant="h6" sx={{ textAlign: "center" }}>
              No participant found
            </MDTypography>
          ) : (
            activeUser &&
            activeUser
              .filter(
                (item) =>
                  !participantList?.some(
                    (p) =>
                      p.extensions === item.contact || p.number === item.contact
                  )
              )
              .filter((item) =>
                item.contact?.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .map((item, index) => (
                <ListItem
                  key={item.uuid}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                    py: 1,
                    backgroundColor:
                      index % 2 === 0
                        ? theme.palette.background.default
                        : theme.palette.action.hover,
                  }}
                >
                  <Grid container alignItems="center" sx={{ flex: 1 }}>
                    <Grid item xs={4}>
                      <MDTypography variant="body2">
                        <PersonOutlineIcon
                          sx={{ mr: 1 }}
                          color="success"
                          fontSize="medium"
                        />{" "}
                        {conferenceData?.contact === item.contact ||
                        conferenceData?.mobileNumber === item.contact
                          ? "Moderator"
                          : "Guest Participant"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={4}>
                      <MDTypography variant="body2">
                        {item.contact}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={4}>
                      <Box display="flex" alignItems="center" gap={1}>
                        {getColorForContact(item.contact) === "success" &&
                          (getColorCallType(item.contact) ? (
                            <MDTypography variant="body2">
                              Joined via Video Call
                            </MDTypography>
                          ) : (
                            <MDTypography variant="body2">
                              Joined via Audio Call
                            </MDTypography>
                          ))}
                        {phoneType === "moderator" &&
                          (getMuteStatus(item.contact) ? (
                            <tooltip title="Unmute">
                              <IconButton
                                onClick={() => handleMute(item.contact)}
                              >
                                <Icon color="success">mic</Icon>
                              </IconButton>
                            </tooltip>
                          ) : (
                            <tooltip title="Mute">
                              <IconButton
                                onClick={() => handleUnMute(item.contact)}
                              >
                                <Icon color="error">mic_off</Icon>
                              </IconButton>
                            </tooltip>
                          ))}
                        {phoneType === "moderator" &&
                          getColorForContact(item.contact) === "success" && (
                            <tooltip title={"Remove"}>
                              <IconButton
                                onClick={() =>
                                  handleExternalParticipantDelete(item)
                                }
                              >
                                <Icon color="error">
                                  remove_circle_outline_icon
                                </Icon>
                              </IconButton>
                            </tooltip>
                          )}
                      </Box>
                    </Grid>
                  </Grid>
                </ListItem>
              ))
          )}
        </List>
      </MDBox>

      <CTLBaseDialogForm
        entityName="Add participant in conference"
        columns={getColumns()}
        openForm={openForm}
        onSaveForm={onSaveForm}
        onCloseForm={onCloseForm}
        formData={formData}
        pageAttributes={Attributes}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default CTLConferenceUserList;
